import { useCallback, useReducer } from 'react';

import { Metadata } from '@redwoodjs/web';

import { SepaAgreementTables } from 'src/features/finance/sepaDirectDebits/components/SepaAgreementTables/SepaAgreementTables';
import SepaDDForm from 'src/features/finance/sepaDirectDebits/components/SepaForms/SepaDDForm';
import { PageContent } from 'src/layouts/MainLayout/PageContent';

function DirectDebitsPage() {
    const [shouldRefetchTableData, triggerRefetchTableData] = useReducer((count) => {
        return count + 1;
    }, 0);

    const onSendSepaDD = useCallback(() => {
        triggerRefetchTableData();
    }, []);

    return (
        <PageContent
            heading="Setup New Direct Debit Mandates"
            subHeading="Add New Direct Debit Mandate for billing purposes"
        >
            <Metadata title="Direct Debit Mandates" description="Setup New Direct Debit Mandates" />
            <SepaDDForm onSendSepaDD={onSendSepaDD} />
            <SepaAgreementTables shouldRefetch={shouldRefetchTableData} />
        </PageContent>
    );
}

export default DirectDebitsPage;
